import script from "./ActionBid.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionBid.vue?vue&type=script&setup=true&lang=js"

import "./ActionBid.vue?vue&type=style&index=0&id=21444b60&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21444b60"]])

export default __exports__